import { render, staticRenderFns } from "./questionnair.vue?vue&type=template&id=5e2302be&scoped=true"
import script from "./questionnair.vue?vue&type=script&lang=js"
export * from "./questionnair.vue?vue&type=script&lang=js"
import style0 from "./questionnair.vue?vue&type=style&index=0&id=5e2302be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2302be",
  null
  
)

export default component.exports